import { Image } from 'react-native'
import { Images as foundationImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

const Images = {
  //foundation images
  chevronRightRed: foundationImages.ic_chevron_right_red,
  vf_logo: foundationImages.vfLogo,
  //HIFI images
  tick: Image.resolveAssetSource(require('./../Images/Icons/HIFI/tick.png')),
  miniSim: Image.resolveAssetSource(require('./../Images/Icons/HIFI/mini-sim.png')),
  microSim: Image.resolveAssetSource(require('./../Images/Icons/HIFI/micro-sim.png')),
  nanoSim: Image.resolveAssetSource(require('./../Images/Icons/HIFI/nano-sim.png')),
  spotify: Image.resolveAssetSource(require('./../Images/Icons/HIFI/Spotify.png')),
  netflix: Image.resolveAssetSource(require('./../Images/Icons/HIFI/Netflix.png')),
  simCard: Image.resolveAssetSource(require('./../Images/Icons/HIFI/simCard.png')),
  success: Image.resolveAssetSource(require('./../Images/Icons/HIFI/success.png')),
  warning: Image.resolveAssetSource(require('./../Images/Icons/HIFI/warning.png')),

  //icons
  smsText: Image.resolveAssetSource(require('./../Images/Icons/Icons/sms_text.png')),
  smsTextWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/sms_text_white.png')),
  landline: Image.resolveAssetSource(require('./../Images/Icons/Icons/landline.png')),
  landlineWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/landline_white.png')),
  dataSharing: Image.resolveAssetSource(require('./../Images/Icons/Icons/data_sharing.png')),
  dataSharingWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/data_sharing_white.png')),
  offerDefaultIcon: Image.resolveAssetSource(require('./../Images/Icons/Icons/offer_default_icon.png')),
  offerDefaultIconWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/offer_default_icon_white.png')),
  ic_chevron_up: Image.resolveAssetSource(require('./../Images/Icons/Icons/ic_chevron_up.png')),
  ic_chevron_down: Image.resolveAssetSource(require('./../Images/Icons/Icons/icChevronDown.png')),
  idCard: Image.resolveAssetSource(require('./../Images/Icons/Icons/idCard.png')),
  idCardWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/idCardWhite.png')),
  address: Image.resolveAssetSource(require('./../Images/Icons/Icons/address.png')),
  addressWhite: Image.resolveAssetSource(require('./../Images/Icons/Icons/addressWhite.png')),
  search: Image.resolveAssetSource(require('./../Images/Icons/Icons/search.png')),

  edit: Image.resolveAssetSource(require('./../Images/Icons/Icons/edit.png')),
  big_sim: Image.resolveAssetSource(require('./../Images/Icons/Icons/big_sim.png')),
  new_sim_light: Image.resolveAssetSource(require('./../Images/Icons/Icons/sim.png')),
  new_sim_dark: Image.resolveAssetSource(require('./../Images/Icons/Icons/sim_dark.png')),
  bundle_light: Image.resolveAssetSource(require('./../Images/Icons/Icons/bundle_light.png')),
  bundle_dark: Image.resolveAssetSource(require('./../Images/Icons/Icons/bundle_dark.png')),
  flash: Image.resolveAssetSource(require('./../Images/Icons/Icons/flash.png')),
  flash_filled: Image.resolveAssetSource(require('./../Images/Icons/Icons/flash_filled.png')),
  close_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/close-white.png')),
  info: Image.resolveAssetSource(require('./../Images/Icons/Icons/info.png')),
  info_white: Image.resolveAssetSource(require('./../Images/Icons/Icons/info-white.png')),
}

export default Images
